
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAbstractAutomationButton as ObcAbstractAutomationButtonElement} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/abstract-automation-button.js';
 
 
 

 
 export const ObcAbstractAutomationButton = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcAbstractAutomationButtonElement,
   events: {
     
   }
  });
 
 